<template>
  <el-dialog
    :visible.sync="currentVisible"
    custom-class="mobile-reservation-dialog"
    :show-close="false"
    width="90%"
    top="50vh"
    :append-to-body="true"
  >
    <div class="dialog-header">
      <h3>预约产品演示</h3>
      <i class="el-icon-close" @click="handleClose"></i>
    </div>
    
    <el-form
      ref="mobileReserveForm"
      :model="mobileReserveForm"
      :rules="mobileReserveRules"
      label-position="top"
    >
      <el-form-item label="姓名" prop="userName">
        <el-input
          v-model="mobileReserveForm.userName"
          placeholder="请输入您的姓名"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="手机号" prop="contactPhone">
        <el-input
          v-model="mobileReserveForm.contactPhone"
          placeholder="请输入您的手机号"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="公司名称" prop="enterpriseName">
        <el-input
          v-model="mobileReserveForm.enterpriseName"
          placeholder="请输入您的公司名称"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="职务">
        <el-input
          v-model="mobileReserveForm.office"
          placeholder="请输入您的职务"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="备注">
        <el-input
          v-model="mobileReserveForm.remark"
          type="textarea"
          :rows="4"
          placeholder="您可以在这儿描述问题和需求，不超过200字"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    
    <div class="dialog-footer">
      <el-checkbox v-model="mobileReserveForm.accept">
        点击提交视为您已阅读并同意
        <a href="#" class="privacy-link">《隐私政策》</a>
      </el-checkbox>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">
        {{ submitting ? '提交中...' : '提交预约' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentVisible: this.visible,
      submitting: false,
      mobileReserveForm: {
        userName: '',
        contactPhone: '',
        enterpriseName: '',
        office: '',
        remark: '',
        accept: false,
      },
      mobileReserveRules: {
        userName: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, message: '姓名至少2个字', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        enterpriseName: [
          { required: true, message: '请输入您的公司名称', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    visible(newVal) {
      this.currentVisible = newVal;
    },
    currentVisible(newVal) {
      this.$emit('update:visible', newVal);
      if (!newVal && this.$refs.mobileReserveForm) {
        this.$refs.mobileReserveForm.resetFields();
        this.mobileReserveForm.accept = false;
      }
    }
  },
  methods: {
    handleClose() {
      this.currentVisible = false;
    },
    handleSubmit() {
      this.$refs.mobileReserveForm.validate(valid => {
        if (valid) {
          if (!this.mobileReserveForm.accept) {
            this.$message.warning('请阅读并同意隐私政策');
            return;
          }
          this.submitting = true;
          // 这里添加提交逻辑
          setTimeout(() => {
            this.$message.success('预约成功！我们会尽快与您联系');
            this.submitting = false;
            this.currentVisible = false;
          }, 1500);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-reservation-dialog {
  border-radius: 16PX;
  overflow: hidden;
  
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  
  .dialog-header {
    padding: 20PX;
    background: linear-gradient(135deg, #1890ff, #52c41a);
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    h3 {
      margin: 0;
      font-size: 18PX;
      font-weight: 500;
    }
    
    i {
      font-size: 20PX;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        transform: rotate(90deg);
      }
    }
  }
  
  .el-form {
    padding: 20PX;
    
    ::v-deep .el-form-item {
      margin-bottom: 20PX;
      
      .el-form-item__label {
        padding: 0;
        line-height: 1.5;
        color: #333;
        font-size: 15PX;
        font-weight: 500;
      }
      
      .el-input__inner {
        height: 44PX;
        border-radius: 8PX;
        border-color: #e8e8e8;
        transition: all 0.3s ease;
        
        &:hover, &:focus {
          border-color: #1890ff;
          box-shadow: 0 0 0 2PX rgba(24, 144, 255, 0.1);
        }
      }
      
      .el-textarea__inner {
        border-radius: 8PX;
        border-color: #e8e8e8;
        padding: 12PX;
        transition: all 0.3s ease;
        
        &:hover, &:focus {
          border-color: #1890ff;
          box-shadow: 0 0 0 2PX rgba(24, 144, 255, 0.1);
        }
      }
    }
  }
  
  .dialog-footer {
    padding: 20PX;
    background: #f9f9f9;
    
    .el-checkbox {
      margin-bottom: 16PX;
      display: block;
      
      ::v-deep .el-checkbox__label {
        color: #666;
        font-size: 14PX;
      }
      
      .privacy-link {
        color: #1890ff;
        text-decoration: none;
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
    
    .el-button {
      width: 100%;
      height: 44PX;
      border-radius: 22PX;
      font-size: 16PX;
      background: linear-gradient(90deg, #1890ff, #52c41a);
      border: none;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2PX);
        box-shadow: 0 4PX 12PX rgba(24, 144, 255, 0.3);
      }
      
      &:active {
        transform: translateY(0);
      }
    }
  }
}

.reservation_dialog {
  @import '@/assets/css/variables.scss';
  
  .dialog_title {
    font-size: $h3-font-size;
    font-weight: $font-weight-semibold;
    color: $text-color-primary;
    text-align: center;
    margin-bottom: 24px;
  }
  
  .form_label {
    font-size: $font-size-base;
    font-weight: $font-weight-medium;
    color: $text-color-primary;
    margin-bottom: 8px;
  }
  
  .form_input {
    font-size: $font-size-base;
    color: $text-color-primary;
    
    &::placeholder {
      color: $text-color-placeholder;
    }
  }
  
  .form_error {
    font-size: $font-size-sm;
    color: $error-color;
    margin-top: 4px;
  }
  
  .submit_btn {
    font-size: $font-size-base;
    font-weight: $font-weight-medium;
    
    &.is-disabled {
      color: $text-color-disabled;
    }
  }
  
  @media (max-width: $screen-md) {
    .dialog_title {
      font-size: $h4-font-size;
    }
    
    .form_label {
      font-size: $font-size-sm;
    }
  }
}
</style> 